export default __webpack_public_path__ + "static/media/muthengi-mbuvi-qixtBdqyNqI-unsplash.f3d8c894.jpg";